import { render, staticRenderFns } from "./xgJNJPersonal.vue?vue&type=template&id=c12728b0&scoped=true&"
import script from "./xgJNJPersonal.vue?vue&type=script&lang=js&"
export * from "./xgJNJPersonal.vue?vue&type=script&lang=js&"
import style0 from "./xgJNJPersonal.vue?vue&type=style&index=0&id=c12728b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12728b0",
  null
  
)

export default component.exports